<template>
  <div class="indexMicro indexReg">
    <Menu mode="horizontal" active-name="1">
      <MenuItem name="1">区域优质资源</MenuItem>
    </Menu>
    <div class="lookmore" @click="viewMore('areaQualityResources')">查看更多
      <Icon type="ios-arrow-forward" />
    </div>
    <div class="microcontentbox">
        <div :gutter="27" class="regcardBox" v-for="(item,index) in dataInfo" :key="index" style="margin-bottom:15px;border: 1px solid #EEF0F4;border-radius: 5px;">
                <Col span="24" class="regcard" v-for="(n,m) in item" :key="m">
                  <div class="regtext" @click="view(n.downloadUrl)" :title="n.name"><span class="regIcon"></span>{{n.name.length >20 ?n.name.slice(0,20)+'...':n.name}}</div>
                  <div class="regtime">{{n.createTime.slice(0,10)}}</div>
                </Col>

         </div>
    </div>
    <message v-show="isShowMessage" :msg="msg" @isShowMsg="isShowMsg" :isShowMessage="isShowMessage"></message>
  </div>
</template>

<script>
  import api from '../../utils/api.js';
  import bus from '../../assets/eventBus/enentBus.js';
  import cookie from '../../assets/getCookie.js';
  import message from '../Message/Message'
  export default {
    name: 'IndexMicro',
    data() {
      return {
        urlHttp:'/testIp',
        microList:null,                                         //微课列表  array
        imgurl:'https://qcban.aixuetang.com/res/',              //微课图片地址  线上域名
        dataInfo:null,
        isShowMessage:false,
        msg:null,
        websiteId:null
      }
    },
    mounted() {
      this.websiteId = localStorage.getItem('websiteId');
      this.getIndexRegData()
    },
    methods: {
      //学堂资源
      getIndexRegData(){
         const that = this;
         const result = [];
        //const url =  '/axt-future/knowledgePPT/pageKnowledgePPTsByCondition';
        const url =  '/axt-data/dataPPT/pageDataPPT';
          const params = {
              pageNo:1,
              pageSize:50,
              gradeIds:null,
              subjectId:null,
              versionId:null,
              id:null,                                          //教材id
              knowledgeId:null,
              //shareNetId:1
              shareWebsiteId: this.websiteId                                    //区域id
          }
          //console.log(params,'params')
          api.getListAPI(url,params).then(res => {
              //console.log('资源',res)
              const dataInfo = res.data.data.rows;
              for (let i = 0; i < 21; i += 7) {
                result.push(dataInfo.slice(i, i + 7));
              }
              that.dataInfo = result;
          }).catch(err => {
              console.log(err)
          })
      },
      viewMore(name) {
        this.$router.push({
          name: name
        });
        this.$emit('routerMicroName', name);
        this.$nextTick(()=>{
          $("body").scrollTop(0);
        })
      },
      view(url){
        if(!localStorage.getItem('schoolId')) {
          this.isShowMessage = true;
          this.msg = '您尚未登录,请登录后查看！';
          return
        }
          this.$emit("isplay",true)
          if (/\.ppt/gi.test(url) || /\.pptx/gi.test(url)
              || /\.doc/gi.test(url) || /\.docx/gi.test(url)
              || /\.xls/gi.test(url) || /\.xlsx/gi.test(url)
              || /\.jpg/gi.test(url) || /\.png/gi.test(url)
              || /\.pdf/gi.test(url)) {
                  this.getMaterialUrl(url);
          }else {
              const src = 'https://qcban.aixuetang.com/res' + url;
              bus.$emit('materialSrc',src)
          }
      },
      getMaterialUrl(src){
          const that = this;
          const url =  '/axt-resources/preview/selectDocumentPreviewUrl';
          const params = {
              'downloadUrl':src
          }
          api.getListAPI(url,params).then(res => {
              // console.log('资料预览链接',res)
              bus.$emit('materialSrc',res.data.data)
          })
      },
      isShowMsg(msg){
          this.isShowMessage = false;
      }
    },
    components:{message}
  }
</script>

<style>
  .indexReg {
    position: relative;
  }

  .indexReg .ivu-menu {
    z-index: 0;
  }

  .indexReg .regcardBox {
    width: 32%;
    margin-right: 2%!important;
  }
  .regcardBox:last-of-type {
    margin-right: 0!important;
  }
  .regcard {
    height: 45px;
    border-bottom: 1px solid #EEF0F4;
    line-height: 45px;
    display: flex!important;
    cursor: pointer;
    font-size: 16px;
  }
  .regcard:hover {
    color: #2d8cf0;
    border: 1px solid #3583FF;
  }
  .regcard:nth-of-type(odd){
    background: #FBFBFC;
  }
  .regcard .regtext .regIcon {
    display: inline-block;
    height:12px ;
    width: 12px;
    background: url(/static/images/regImg.png) no-repeat;
    background-size: cover;
    margin-right: 10px;
    margin-left: 5%;
  }
  .regcard:hover .regtext .regIcon {
    background: url(/static/images/regImgbg.png) no-repeat;
    background-size: cover;
  }
  .regcard .regtext {
    flex: 9;
    text-align: left;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .regcard .regtime {
    flex: 3;
    margin-right: 5%;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/IndexRegional.vue